export default {
    objectHasNonDefaultFields (input) {
        for (var property in input) {
            if (typeof input[property] === 'object' && input[property] !== null) {
                if (this.objectHasNonDefaultFields(input[property]) === true) {
                    return true
                }
            } else if (input[property]) {
                return true
            }
        }
        return false
    },
    copyObject (input) {
        var output = {}
        for (var property in input) {
            output[property] = input[property]
        }
        return output
    },
    deepCopyObject (input) {
        if (input === null) {
            return null
        }
        if (input === undefined) {
            return undefined
        }
        if ((typeof input === 'object')) {
            var outputObject = {}
            for (var property in input) {
                outputObject[property] = this.deepCopy(input[property])
            }
            return outputObject
        }
        if (Array.isArray(input[property])) {
            var outputArray = []
            for (var element in input) {
                outputArray.push(this.deepCopy(input[element]))
            }
            return outputArray
        }
        return input
    },
}
